import { render, staticRenderFns } from "./LineChart.vue?vue&type=template&id=04839bb8&scoped=true"
import script from "./LineChart.vue?vue&type=script&lang=js"
export * from "./LineChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04839bb8",
  null
  
)

export default component.exports